import { Grid, Table, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { endpoint } from '../../resource/Constant';

function ResultPage() {
  const [questions, setQuestions] = useState([]);
  const [communication, setCommunication] = useState(0);
  const [overallScore, setOverallScore] = useState(0);
  const [confidence, setConfidence] = useState(0);
  const [topicviceresult, setTopicviceresult] = useState([]);
  const [interview, setInterview] = useState({});
  const params = useParams();
  const par = {
    interview_id: params.interviewid,
    token: localStorage.getItem('authToken')
  };
  const navigate = useNavigate();

  const getallquestions = () => {
    axios
      .get(endpoint + '/api/interview/showresult', { params: par })
      .then((res) => {
        if (res.status == 200) {
          setQuestions(res.data);
          if (res.data.length > 0) {
            setCommunication(res.data.reduce((partialSum, a) => partialSum + a.communication, 0) / res.data.length);

            setOverallScore(res.data.reduce((partialSum, a) => partialSum + a.correctness, 0) / res.data.length);

            setConfidence(res.data.reduce((partialSum, a) => partialSum + a.confidence, 0) / res.data.length);

            setTopicviceresult(
              res.data
                .map((e) => e.topic)
                .filter((value, index, array) => {
                  return array.indexOf(value) === index;
                })
                .map((e) => {
                  let availablequestion = res.data.filter((filterelment) => filterelment.topic === e);
                  let comm = availablequestion.reduce((partialSum, a) => partialSum + a.communication, 0) / availablequestion.length;
                  let accuracy = availablequestion.reduce((partialSum, a) => partialSum + a.correctness, 0) / availablequestion.length;

                  let confidence = availablequestion.reduce((partialSum, a) => partialSum + a.confidence, 0) / availablequestion.length;
                  return {
                    topic: e,
                    communication: comm,
                    correctness: accuracy,
                    confidence: confidence
                  };
                })
            );
          }
        }
      })
      .catch((e) => {
        navigate(-1);
      });
  };

  const getInterview = () => {
    axios
      .get(endpoint + '/api/interview/getbyid', { params: par })
      .then((res) => {
        setInterview(res.data);
      })
      .catch((e) => {
        // navigate(-1);
      });
  };
  useState(() => {
    getallquestions();
    getInterview();
  }, []);
  return (
    <Grid container p={{ xs: 0, md: 1 }} border={'solid rgb(13, 27, 42) 1px'} borderRadius={'5px'}>
      <Grid alignItems={'center'}>
        <Typography alignItems={'left'} alignContent={'flex-start'} color="#008267" variant="h5" fontWeight={700}>
          Result
        </Typography>
      </Grid>
      <Grid container>
        <Grid item xs={8}>
          <Typography color="#008267" fontWeight={500} variant="h5">
            Interview Id:{interview.id}
          </Typography>
          <Typography color="#008267" fontWeight={500} variant="h5">
            Interview Technology:{interview.technology}
          </Typography>
        </Grid>
      </Grid>
      <Grid m={2} alignItems={'center'} alignContent={'center'} container spacing={3}>
        <Grid
          m={1}
          p={1}
          border={'solid rgb(13, 27, 42) 2px'}
          sx={{
            backgroundImage: 'linear-gradient(123deg, #008559 0%, #008267 50%, #007f76 100%)'
          }}
          borderRadius={'5px'}
          item
          xs={12}
          md={3}
        >
          <Grid>
            <Typography fontWeight={600} color="white" variant="h5">
              Communication
            </Typography>
          </Grid>
          <Grid>
            <Typography fontWeight={600} color="white" variant="h4">
              {(Math.round(communication * 100) / 100).toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          m={1}
          p={1}
          border={'solid rgb(13, 27, 42) 2px'}
          sx={{
            backgroundImage: 'linear-gradient(123deg, #008559 0%, #008267 50%, #007f76 100%)'
          }}
          borderRadius={'5px'}
          item
          xs={12}
          md={3}
        >
          <Grid>
            <Typography fontWeight={600} color="white" variant="h5">
              Overall Score
            </Typography>
          </Grid>
          <Grid>
            <Typography fontWeight={600} color="white" variant="h4">
              {(Math.round(overallScore * 100) / 100).toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          m={1}
          p={1}
          border={'solid rgb(13, 27, 42) 2px'}
          sx={{
            backgroundImage: 'linear-gradient(123deg, #008559 0%, #008267 50%, #007f76 100%)'
          }}
          borderRadius={'5px'}
          item
          xs={12}
          md={3}
        >
          <Grid>
            <Typography fontWeight={600} variant="h5" color="white">
              Confidence
            </Typography>
          </Grid>
          <Grid>
            <Typography fontWeight={600} variant="h4" color="white">
              {(Math.round(confidence * 100) / 100).toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
        {/* <Grid item sx={4}>
            <Typography>Number</Typography>
          </Grid> */}
      </Grid>
      <Grid container>
        <Grid>
          <Typography variant="h6" fontWeight={400}>
            Topic-wise Score
          </Typography>
        </Grid>
        {/* <Grid width={{ xs: 300, sm: 400, md: 900 }} overflow={"auto"}> */}
        <TableContainer sx={{ m: 1 }}>
          <Table
            style={{
              border: 'rgb(13, 27, 42) solid 2px',
              borderRadius: '10px'
            }}
          >
            <TableHead
              sx={{
                color: 'white',
                backgroundImage: 'linear-gradient(123deg, #007f76 0%, #007c85 50%, #007994 100%)'
              }}
            >
              <TableRow color="white">
                <TableCell>
                  <b>Topic</b>
                </TableCell>
                <TableCell>
                  <b>Accuracy</b>
                </TableCell>
                <TableCell>
                  <b>Communication</b>
                </TableCell>
                <TableCell>
                  <b>Confidence</b>
                </TableCell>
              </TableRow>
            </TableHead>
            {topicviceresult.map((e) => (
              <TableRow>
                <TableCell>{e.topic}</TableCell>
                <TableCell>{(Math.round(e.correctness * 100) / 100).toFixed(2)}</TableCell>
                <TableCell>{(Math.round(e.communication * 100) / 100).toFixed(2)}</TableCell>
                <TableCell>{(Math.round(e.confidence * 100) / 100).toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
}

export default ResultPage;
